import i18n from '../i18n'

const slidebarData = [
  // {
  //   name: 'Product',
  //   label: 'Product',
  //   link: 'product',
  //   icon: 'product'
  // },
  // {
  //   name: 'Outlet',
  //   label: 'Outlet',
  //   link: 'outlet',
  //   icon: 'outlet'
  // },
  // {
  //   name: 'Register',
  //   label: 'Register',
  //   link: 'register',
  //   icon: 'register'
  // },
  {
    name: 'Revenue',
    label: i18n.t('total_revenue'),
    link: 'totalRevenue',
    icon: 'revenue'
  },
  {
    name: 'Orders',
    label: i18n.t('orders'),
    link: 'numberOfOrders',
    icon: 'orders'
  },
  {
    name: 'Product Sold',
    label: i18n.t('products'),
    link: 'productSold',
    icon: 'products'
  },
  {
    name: 'Tax',
    label: i18n.t('tax'),
    link: 'tax',
    icon: 'tax'
  },
  {
    name: 'Global',
    label: i18n.t('global'),
    link: 'global',
    icon: 'global'
  }
]

export default slidebarData
